export const Report = {
  lessonReportTemplateItemTypeNames: new Map([
    ['boolean', '체크형'],
    ['select', '선택형'],
    ['score', '점수형'],
    ['grade', '그레이드형'],
    ['text', '텍스트'],
  ]),
  examTemplateItemTypeNames: new Map([
    ['score', '점수형'],
    ['grade', '그레이드형'],
    ['text', '텍스트'],
  ]),
};
